import React, { Component } from "react";
import logoVector from "../resources/image/login_logo.png";
import { connect } from "react-redux";
import { please_login, login_with_mobile } from "../resources/string/strings"

class AutenticationHome extends Component {
  state = {
    pageTitle: "ورود به حساب",
    pageTag: "authenticationHome",
  };

  componentDidMount() {
    document.title = this.state.pageTitle;
  }

  render() {
    this.checkLogin();
    var isLogin = this.props.login.isLogin === "true"
    return (
      <div className="fragment">
        {!isLogin &&
          <div className="app-card mx-auto text-center bg-white col-12 col-sm-12 col-md-9 col-lg-7 col-xl-6">

            <div className="card-body">
              <img
                style={{ width: 110 }}
                className="mb-5"
                src={logoVector}
                alt="Marex"
              />
              <div style={{ fontSize: 14 }} className="mb-5">{please_login}</div>
              <button
                style={{ width: 240, height: 45, paddingBottom: 6 }}
                className="btn d-flex align-items-center mx-auto btn-success mb-3"
                onClick={this.handleAuthMobileClick}
              >
                <div className="mx-auto">{login_with_mobile}</div>
              </button>
            </div>

          </div>
        }
      </div>
    );
  }

  checkLogin() {
    if (this.props.login.isLogin === "true") {
      this.props.history.go(-1);
    }
  }

  handleAuthMobileClick = () => {
    this.props.history.push("/authenticationMobile");
  };
}

//// REDUX STUFF
function mapStateToProps(state) {
  return {
    login: state.login,
  };
}

export default connect(mapStateToProps)(AutenticationHome);

